<template>
  <div>
    <template v-if="relatedDocuments?.length">
      <div class="d-flex align-center justify-space-between ga-3 mb-3">
        <div>
          Повʼязаних документів: <b>{{ relatedDocuments.length }}</b>
        </div>
        <v-btn
          v-if="!readonly"
          color="light-blue-darken-4"
          :loading="$loading.isLoading('relatedDocumentCreate')"
          @click="relatedDocumentCreate">
          <v-icon class="mr-2" icon="mdi-link-variant"></v-icon>
          <span>Додати документ</span>
        </v-btn>
      </div>
      <v-card v-for="doc in relatedDocuments" :key="doc.id" border class="mb-3">
        <v-card-text>
          <div class="d-flex align-center justify-space-between ga-3">
            <div class="d-flex align-center ga-3">
              <div class="icon--blue">
                <v-icon icon="mdi-file-outline"></v-icon>
              </div>

              <div>
                <div
                  class="link font-weight-bold mb-2 font-size-15"
                  @click="navigateToItem('document-agreement-single', doc.id)">
                  {{ doc.name }}
                </div>
              </div>
            </div>

            <div v-if="!readonly">
              <v-btn
                v-tooltip="'Видалити звʼязок'"
                color="error"
                density="compact"
                icon="mdi-close"
                variant="outlined"
                :loading="$loading.isLoading('relatedDocumentDelete')"
                @click="relatedDocumentDelete(doc.id)"></v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </template>

    <div v-else>
      <empty-section
        description="Натисніть «Додати документ» щоб звʼязати документи"
        title="Немає повʼязаних документів"></empty-section>
      <v-divider class="my-4"></v-divider>
      <div class="d-flex justify-end">
        <v-btn
          v-if="!readonly"
          color="light-blue-darken-4"
          :loading="$loading.isLoading('relatedDocumentCreate')"
          @click="relatedDocumentCreate">
          <v-icon class="mr-2" icon="mdi-link-variant"></v-icon>
          <span>Додати документ</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useDocumentAgreement } from '../documentAgreement'
import { navigateToItem } from '@/utils/helpers'
import { CustomDate } from 'best-modules/utils'
import EmptySection from '@/components/EmptySection.vue'

export default {
  name: 'RelatedDocuments',
  components: { EmptySection },
  methods: { navigateToItem, CustomDate },
  setup() {
    const {
      relatedDocuments,
      readonly,
      relatedDocumentCreate,
      relatedDocumentDelete,
    } = useDocumentAgreement()

    return {
      relatedDocuments,
      relatedDocumentCreate,
      relatedDocumentDelete,
      readonly,
    }
  },
}
</script>

<style scoped lang="scss"></style>
